import { useState } from 'react';
import {
    FormControl, Grid, ListItemText, MenuItem, Select, SelectChangeEvent,
} from '@mui/material';
import { FilterWidget } from '@tap/tap-ui';
import { IFilterContext, createFilterExports } from '@tap/tap-ui';
import { IComponentCss } from '@tap/mui-ui';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { useDocumentSchemaContext } from '@tap/doc-ui';
import { ManufactureAndSectorMultiSelect, useDepartment } from '@tap/tap-ui';

/**
 *  Фильтр
 */

export type HomeFilterValue = {
    manufactories: string[],
    sectors: string[],
    departmentIds: number[],
    isueType: string[],
}

export const defaultFilterValue: HomeFilterValue = {
    manufactories: [],
    sectors: [],
    departmentIds: [],
    isueType: [],
}

const css: IComponentCss = {
    select: {
        backgroundColor: '#ffffff',
    },
    checkIcon: {
        height: '20px',
        width: '20px',
        marginRight: '5px',
    },
    menuItem: {
        padding: '5px 6px',
    },
}


// Для выпадающих списков - выводит количество выбранных элементов
const renderSelectValue = (
    label: string,
    arrayOfElements: any[] | undefined,
    arrayOfSelectedElements: any[] | undefined,
): string => {
    // состояние: все
    if (
        (arrayOfSelectedElements?.length === 0)
        || (arrayOfSelectedElements?.length === arrayOfElements?.length)
    )
        return label + ': все'
    else
        return label + ': ' + arrayOfSelectedElements?.length + '/' + arrayOfElements?.length
};



const Filter = ({ defaultValue, filterValue, applyFilter }: IFilterContext<any>) => {

    const [formValue, setFormValue] = useState<HomeFilterValue>(filterValue || defaultValue);
    const manufactureAndSectorMultiSelectProps = useDepartment();
    const { schemaList } = useDocumentSchemaContext();
    const isueTypeList = schemaList
        .filter(dc => dc.settings.typeList)
        .map(dc => dc.settings.typeList.map((item: any) => {
            return {
                ...item,
                code: `${item.code}-${dc.documentCode}`,
            }
        }),
        )
        .flat();




    const handleCleanFilter = () => {
        setFormValue(defaultValue);
        applyFilter(defaultValue);
    };


    // Типы заявок: обработчик для выпадающего списка 
    const handleChangeSelectedWorkplaces = (e: SelectChangeEvent<string[]>) => {
        setFormValue({ ...formValue, isueType: e.target.value as string[] });
    };


    const handleApplyFilter = () => {
        applyFilter(formValue);
    };

    return (
        <FilterWidget
            title={'Фильтр'}
            handleCleanFilter={handleCleanFilter}
            handleUpdateFilter={handleApplyFilter}
        >
            <>
                <ManufactureAndSectorMultiSelect
                    {...manufactureAndSectorMultiSelectProps}
                    value={{
                        manufactories: formValue.manufactories,
                        sectors: formValue.sectors,
                        departmentIds: formValue.departmentIds,
                    }}
                    onChange={({ manufactories, sectors, departmentIds }) => setFormValue({ ...formValue, manufactories, sectors, departmentIds })}
                />

                {/*Выпадающий список: Рабочее место */}
                <Grid container item>
                    <FormControl fullWidth sx={css.select}>
                        <Select
                            size='small'
                            multiple
                            value={formValue.isueType}
                            onChange={handleChangeSelectedWorkplaces}
                            displayEmpty={true}
                            renderValue={() =>
                                renderSelectValue(
                                    'Типы заявок',
                                    isueTypeList,
                                    formValue.isueType,
                                )}
                        >
                            {isueTypeList?.map((applicationType) =>
                                <MenuItem
                                    key={applicationType.code}
                                    value={applicationType.code}
                                    sx={css.menuItem}
                                >
                                    <CheckOutlinedIcon
                                        sx={{
                                            ...css.checkIcon,
                                            visibility: formValue.isueType.indexOf(applicationType.code) > -1 ? 'visible' : 'hidden',
                                        }}
                                    />
                                    <ListItemText primary={applicationType.name} />
                                </MenuItem>,
                            )}
                        </Select>
                    </FormControl>
                </Grid>
            </>
        </FilterWidget>
    );
}


export const HomeFilter = createFilterExports<HomeFilterValue, any>(Filter);
